import React from 'react';
import Text from '@/components/Text';
import { SlideProps } from './slideTypes';
import { SLIDE_TITLE_SIZE, SLIDE_TEXT_SIZE } from './slideConstants';

export function TextSlide({ slide, firstTextSlide }: SlideProps) {
  const textContent = slide.data?.content || slide.data || '';
  const isFirstTextSlide = slide.id === firstTextSlide?.id;
  
  let title = '';
  let remainingText = textContent;
  
  if (isFirstTextSlide && textContent && typeof textContent === 'string') {
    const firstSentenceMatch = textContent.match(/^[^.!?]+[.!?]/);
    if (firstSentenceMatch) {
      title = firstSentenceMatch[0].trim();
      remainingText = textContent.substring(firstSentenceMatch[0].length).trim();
    }
  }
  
  return (
    <div className="flex flex-col gap-3 md:gap-4 w-full px-4 md:px-6 py-6 md:py-8 items-start justify-center">
      {isFirstTextSlide && title ? (
        <>
          <Text size={SLIDE_TITLE_SIZE} className="text-white font-normal leading-tight mb-1 md:mb-2 text-left text-lg md:text-xl">
            {title}
          </Text>
          {remainingText ? (
            <Text size={SLIDE_TEXT_SIZE} className="text-white/90 leading-[2] text-left text-lg md:text-lg">
              {remainingText}
            </Text>
          ) : null}
        </>
      ) : (
        <Text size={SLIDE_TEXT_SIZE} className="text-white/90 leading-[2] text-left text-lg md:text-lg">
          {textContent}
        </Text>
      )}
    </div>
  );
}
